angular.module('impactx.reLoginExternal').controller('ReloginExternalCtrl', [
    '$scope',
    '$mdDialog',
    'AppConfiguration',
    'LegalLinking',
    ReloginExternalCtrl]);

function ReloginExternalCtrl($scope, $mdDialog, AppConfiguration, LegalLinking) {
    $scope.currentYear = AppConfiguration.get('copyRightYear');
    $scope.imprintURL = AppConfiguration.get('imprintURL');
    $scope.privacyPolicy = AppConfiguration.get('privacyPolicy');
    $scope.generalTerms = AppConfiguration.get('generalTerms');
    $scope.removeCopyRight = AppConfiguration.get('removeCopyRight');

    $mdDialog.show({
        templateUrl: 'modules/reloginexternal/templates/relogin.external.dialog.tmpl.html',
        controller: 'ReLoginExternalDialogController',
        controllerAs: "reloginExternalDialogCtrl",
        clickOutsideToClose: false,
        escapeToClose: false,
        fullscreen: false
    });

    $scope.openDialog = function (ev, link, title) {
        LegalLinking.openDialog(ev, link, title);
    };
}
